import moment from 'moment';

import {daysOfWeek} from '../types/DayOfWeek';

export const dayOfWeekTemplate = (date: Date) => {
   const dayOfWeekNumb = moment(date).weekday();
   const dayOfWeek = daysOfWeek.options[dayOfWeekNumb].name;
   return dayOfWeek;
};
